export const CDN_URL_FOR_PROJECT: Record<string, string> = {
  'enotice-production': 'https://cdn.column.us',
  'enotice-demo-8d99a': 'https://demo.cdn.column.us',
  'column-yaz': 'https://yaz.cdn.column.us'
} as const;
